import React from "react";
import { WHATSAPP, MAPS_URL, openExternal } from "@/lib/contact";
import BrandIcon from "@/components/BrandIcon";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-white/10 bg-[#0A0A0C] py-12"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
        <div>
          <div className="flex items-center gap-2.5 mb-4">
            <BrandIcon size={36} />
            <span className="font-display font-semibold">3D PRINT HUB</span>
          </div>
          <p className="text-zinc-500 text-xs leading-relaxed">
            Precision additive prototyping & CAD modeling out of Gunjur Village, Bengaluru.
          </p>
        </div>
        <div>
          <div className="label-overline mb-3">Studio</div>
          <ul className="space-y-2 text-sm text-zinc-400">
            <li>Gunjur Village, Kodathi Road</li>
            <li>Bengaluru, KA 560087</li>
            <li>Mon — Sat · 10:00 to 20:00</li>
          </ul>
        </div>
        <div>
          <div className="label-overline mb-3">Contact</div>
          <ul className="space-y-2 text-sm text-zinc-400 font-mono">
            <li><a href="tel:+918088163846" className="hover:text-[#FF5722]">+91 80881 63846</a></li>
            <li><a href={WHATSAPP} target="_blank" rel="noreferrer" onClick={(e) => openExternal(e, WHATSAPP)} className="hover:text-[#FF5722]">WhatsApp</a></li>
            <li><a href={MAPS_URL} target="_blank" rel="noreferrer" onClick={(e) => openExternal(e, MAPS_URL)} className="hover:text-[#FF5722]">Google Maps</a></li>
          </ul>
        </div>
        <div>
          <div className="label-overline mb-3">Materials</div>
          <div className="flex flex-wrap gap-1.5">
            {["PLA", "PETG", "ABS", "Nylon-CF", "TPU", "SLA", "Silk-PLA"].map((m) => (
              <span key={m} className="font-mono text-[10px] px-2 py-1 border border-white/10 text-zinc-400">
                {m}
              </span>
            ))}
          </div>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-10 pt-6 border-t border-white/5 flex flex-col sm:flex-row justify-between gap-3 text-[11px] font-mono text-zinc-600 uppercase tracking-[0.2em]">
        <span>© {new Date().getFullYear()} 3D Print Hub Bengaluru</span>
        <span>Shaping imagination into reality</span>
      </div>
    </footer>
  );
}
